import styled from "@emotion/styled";
import { Typography,Button,Grid,Container } from "@mui/material";

const PageWrapper = styled.div`
    /* background-color: ${ (props) => props.theme.pageColor}; */
    min-height: 100vh;
    position: relative;
    display: flex;
`
const MainContainer = styled(Container)`
    display: flex;
    justify-content: center;
    padding-bottom: 50px;
    padding-top: 80px;
`
const P = styled(Typography)`
  color:#fff;
  font-size:15px;
  font-family: poppinR;
  margin-top: 10px;
  @media (max-width: 1024px) and (min-width: 601px){
    font-size:13px;
  }
`
const ImgGrid = styled(Grid)`
    display: flex;
    justify-content:center;
`
const BuyBtn = styled(Button)`
    background-image: url("./assets/yellow-bg.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    color:#000;
    font-family: poppinB;
    font-size:18px;
    margin-right: 10px;
    margin-top: 10px;
    width:150px;
    height:50px;
    @media(max-width: 600px){
        font-size:15px;
        padding:10px 20px;
        margin-right: 10px;
        margin-top: 10px;
    }
`
const ChartBtn = styled(Button)`
    background-image: url("./assets/black-bg.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    color:#fff;
    font-family: poppinB;
    font-size:18px;
    width:150px;
    height:50px;
    margin-top: 10px;
    @media(max-width: 600px){
        font-size:15px;
        padding:10px 20px;
        margin-right: 10px;
        margin-top: 10px;
    }
`
const ContentGrid = styled(Grid)`
    display:flex;
    flex-direction: column;
    justify-content: center;   
`
const VideoBK = styled.video`
    object-fit: cover;
    width: 100%;
    min-height: 100%;
    position: absolute;
    z-index: -1;
`

export { PageWrapper,P,BuyBtn,ChartBtn,ContentGrid,VideoBK,MainContainer,ImgGrid, }